import styles from './styles.module.scss';
import { FC, useEffect, useState } from 'react';

type Props = {
  inputValue?: number;
  onBlur: (val: number) => void;
  minWidth?: number;
  isDisabled?: boolean;
  decimalPlaces?: number;
  maxValue?: number;
  isError?: boolean;
  setBackColor?: boolean;
};

export const NumberInput: FC<Props> = ({
  inputValue,
  onBlur,
  minWidth,
  isDisabled,
  decimalPlaces = 2,
  maxValue,
  isError,
  setBackColor
}) => {
  const [value, setValue] = useState<string>();

  useEffect(() => {
    if (!inputValue) {
      setValue((0).toFixed(decimalPlaces));
    } else {
      const num = Number(inputValue);
      setValue(isNaN(num) ? (0).toFixed(decimalPlaces) : num.toFixed(decimalPlaces));
    }
  }, [inputValue, decimalPlaces]);

  const handleChange = (newValue?: string) => {
    let val = newValue?.replace(',', '.') ?? '0';

    const regex = new RegExp(`^\\d*(\\.\\d{0,${decimalPlaces}})?$`);
    if (!regex.test(val)) {
      return;
    }

    const newVal = Number(val);

    if (isNaN(newVal)) return;

    if (maxValue !== undefined && newVal > maxValue) {
      val = maxValue.toString();
    }

    setValue(val);
  };

  const handleBlur = () => {
    const newVal = Number(value);
    onBlur(isNaN(newVal) ? 0 : newVal);
    setValue((isNaN(newVal) ? 0 : newVal).toFixed(decimalPlaces));
  };

  return (
    <input
      type="text"
      step="any"
      className={`form-control form-control-solid ${isError ? 'border-danger' : ''} ${styles.inputText}`}
      value={value ?? (0).toFixed(decimalPlaces)}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={handleBlur}
      style={{ minWidth: `${minWidth ?? 0}px`, ...(setBackColor ? { backgroundColor: '#fff5f8' } : {}) }}
      disabled={isDisabled ?? false}
      max={maxValue}
    />
  );
};
